import { render, staticRenderFns } from "./DashboardScreen.vue?vue&type=template&id=bc748acc"
import script from "./DashboardScreen.vue?vue&type=script&lang=js"
export * from "./DashboardScreen.vue?vue&type=script&lang=js"
import style0 from "./DashboardScreen.vue?vue&type=style&index=0&id=bc748acc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports